module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-right mb-1"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-badge', {
          attrs: {
            "value": _vm.messages.length,
            "content": _vm.messages.length,
            "color": "black",
            "overlap": ""
          }
        }, [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "text": "",
            "small": "",
            "aria-label": _vm.title + ' comments'
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "color": "secondary"
          }
        }, [_vm._v("chat")])], 1)], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-card', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "width": "300"
    }
  }, [_c('chatbox', {
    attrs: {
      "messages": _vm.messages,
      "title": _vm.title
    },
    on: {
      "sendMessage": function($event) {
        return _vm.$emit('sendMessage', $event)
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2021e2b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Pairing/CreatorConceptForm/EditorComments.vue
// module id = 2034
// module chunks = 0